import _ from "lodash";
import { Arbetsorder } from "./Arbetsorder";
import { IArbetsorderAtgarder } from "./IArbetsorderAtgarder";
import { IAtgard } from "./IAtgard";

export class ArbetsorderList extends Arbetsorder implements IArbetsorderAtgarder {
    filterData?: string;
    atgarder: IAtgard[];
    hover: boolean;

    constructor(arbetsorderListItem: IArbetsorderAtgarder) {
        super(arbetsorderListItem);

        this.filterData = arbetsorderListItem.filterData;
        this.atgarder = _.cloneDeep(arbetsorderListItem.atgarder);
    }
}
